import axios from "axios";
import TableCol from "components/misc/TableCol";
import TableHeader from "components/misc/TableHeader";
import Api from "helpers/Api";
import { useAppContext } from "providers/App";
import { useAuthDataContext } from "providers/Auth";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Refs from "Refs";

function Clients(props) {

    const app = useAppContext();
    const auth = useAuthDataContext();
    const navigate = useNavigate();

    const tableRef = useRef(null);

    const { createMarkup, highlight } = props;

    const [state, setState] = useState({
        loading: false,
        refresh: false,
        setFilter: false,
        data: [

        ],
        filter: {

        },
        request: null,
    });

    useEffect(() => {
        if (props.refresh) {
            loadData();
        }
    }, [state.refresh, props.refresh, props.keyword]);

    useEffect(() => {
        if (state.loading) {
            props.onLoadStart();
        } else {
            props.onLoadEnd();
        }
    }, [state.loading]);

    useEffect(() => {
        props.onResult(state.data.length);
    }, [state.data]);

    const loadData = () => {
        if (state.request) {
            state.request.cancel();
        }

        let request = axios.CancelToken.source();

        setState(prev => ({
            ...prev,
            request: request,
            loading: true,
        }));

        let url = 'search/clients';

        Api.get(url, {
            params: {
                keyword: props.keyword
            },
            cancelToken: request.token
        }).then(res => {
            setState(prev => ({
                ...prev,
                data: res.data.items,
                loading: false,
                sorting: false,
                filter: {
                    ...prev.filter,
                    ...res.data.filter,
                }
            }));
        });
    }

    const showClient = id => {
        let modal = Refs.getInstance().getRef('client');

        modal.open(id);
    }

    const showClients = () => {
        navigate('/clients?search=' + props.keyword);
    }

    if (state.data.length === 0) {
        return null;
    }

    return (
        <Col xl={6} lg={6}>
            <div className="card">
                <div className="d-flex card-header justify-content-between align-items-start">
                    <h4 className="header-title">Клиенти</h4>

                    <Button
                        variant="dark"
                        size="sm"
                        onClick={showClients}
                    >
                        Всички клиенти
                    </Button>
                </div>
                <div className="card-body with-table pt-0">
                    <Table className="" responsive striped hover ref={tableRef}>
                        <TableHeader
                            tableRef={tableRef}
                        >
                            <TableCol>ID</TableCol>
                            <TableCol>Клиент</TableCol>
                            <TableCol>Телефон</TableCol>
                            <TableCol>Е-поща</TableCol>
                            <TableCol>Фирма</TableCol>
                        </TableHeader>
                        <tbody>
                            {state.data.map(c =>
                                <tr
                                    key={'c-' + c.id}
                                    className={c.deleted ? 'deleted' : ''}
                                >
                                    <td>
                                        <span dangerouslySetInnerHTML={createMarkup(highlight(c.id))} />
                                    </td>
                                    <td>
                                        <span className="link" onClick={e => showClient(c.id)} dangerouslySetInnerHTML={createMarkup(highlight(c.name))} />
                                    </td>
                                    <td>
                                        <span dangerouslySetInnerHTML={createMarkup(highlight(c.tel))} />
                                    </td>
                                    <td>
                                        <span dangerouslySetInnerHTML={createMarkup(highlight(c.email))} />
                                    </td>
                                    <td>
                                        <span dangerouslySetInnerHTML={createMarkup(highlight(c.company_name))} />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>
        </Col>
    )
}

export default Clients;